// extracted by mini-css-extract-plugin
export default {"bill-card":"BillRecurringCard_bill-card_owrW6","bill-header":"BillRecurringCard_bill-header_JP2e6","bill-content":"BillRecurringCard_bill-content_fQGCf"};